import { getSearchFieldsApi, getUpdateInfoApi, searchListApi, getAggApi } from '@/apis/api'
import { getAllCfgModuleApi } from '@/apis/lists'
import store from '@/store'
// 企业的检索条件
let companySearchCondtion = [{
  "field": ["org_type"],
  "key": "2",
  "searchType": 2,
  "operType": 1
}]
/* 由于数据中去除了省市后缀，检索时需加上
没匹配上的都是-省
*/
let cityKeyMap = {
  // 四大直辖市
  北京: '北京市',
  天津: '天津市',
  上海: '上海市',
  重庆: '重庆市',
  // 五大自治区
  内蒙古: '内蒙古自治区',
  广西: '广西壮族自治区',
  西藏: '西藏自治区',
  宁夏: '宁夏回族自治区',
  新疆: '新疆维吾尔自治区',
  // 2个特别行政区
  香港: '香港特别行政区',
  澳门: '澳门特别行政区',
}
export const getSearchFieldsMethod = async () => {
  let f = sessionStorage.getItem('commonSearchField') || ''
  let fields = f ? JSON.parse(f) : []
  if (fields?.length > 0) return fields
  let params = {
    moduleCode: 'GWD_search_weapon'
  }
  let res = await getSearchFieldsApi(params)
  sessionStorage.setItem('commonSearchField', (JSON.stringify(res.data || [])))
  return res.data || []
}

// 获取企业、人才、科技成果的数量
export const getComPersonResearchCounts = async () => {
  let comPerResCounts = store.state.comPerResCounts
  if (comPerResCounts) {
    return comPerResCounts
  } else {
    let pieData = [
      {
        label: "医药企业",
        moduleCode: ["medical_search_org"],
        count: 0,
        unit: "家",
        color: "#409EFF",
        iconName: 'yyqy'
      },
      {
        label: "高端人才",
        moduleCode: ["medical_search_author"],
        count: 0,
        unit: "人",
        color: "#67C23A",
        iconName: 'gdrc'

      },
      {
        label: "科技成果",
        moduleCode: [
          'medical_search_all',
          // "medical_search_journal_paper",
          // "medical_search_report",
          // "medical_search_standard",
          // "medical_search_patent",
        ],
        datasetCodes: [
          'medical_journal_paper_data',
          'medical_report_data',
          'medical_standard_data',
          'medical_patent_data'
        ],

        count: 0,
        unit: "个",
        color: "#E6A23C",
        iconName: 'kjcg',
        children: []
      },
    ]
    try {
      pieData.forEach(async item => {
        let res = await searchListApi({
          "moduleCode": item.moduleCode[0],
          "datasetCodes": item.datasetCodes || [],
          "pageIndex": 1,
          "pageSize": 10,
          "maxPage": 0,
          "esSearchObjects": item.moduleCode[0] == 'medical_search_org' ? companySearchCondtion : [],
          "esSortObjects": [],
          "highlightFields": [],
          "esFilterObjects": [],
          "esNestedObjects": []
        })
        item.count = res.data?.total || 0
      })
      //获取成果细项数量
      let res = await getAggApi({
        "moduleCode": "medical_search_all",
        "datasetCodes": [
          'medical_journal_paper_data',
          'medical_report_data',
          'medical_standard_data',
          'medical_patent_data'
        ],
        "esSearchObjects": [],
        "aggField": "data_type",
        "prefixNum": 0,
        "prefix": "",
        "sortType": 0,
        "aggNum": 0,
        "esFilterObjects": [],
        "esNestedObjects": []
      })
      pieData[2].children = res?.data?.aggInfo?.map(item => {
        return {
          name: item.name,
          value: item.count
        }
      })

    } catch (error) {
    }
    store.commit('comPerResCounts', pieData)
    return pieData
  }
}

// 获取各城市企业分布
export const getCitysCompanyCounts = async () => {
  let res = await getAggApi({
    "moduleCode": "medical_search_org",
    "datasetCodes": [],
    "esSearchObjects": companySearchCondtion,
    "aggField": "province",
    "prefixNum": 0,
    "prefix": "",
    "sortType": 0,
    "aggNum": 0,
    "esFilterObjects": [],
    "esNestedObjects": []
  })
  return (res.data?.aggInfo || [])
}
// 获取政策统计
export const getZCData = async (city) => {
  let cityKey = cityKeyMap[city] || (city + '省')
  let res = await getAggApi({
    moduleCode: "medical_search_policy",
    datasetCodes: [],
    esSearchObjects: city ? [{
      field: ['city'],
      key: cityKey,
      searchType: 1,
      operType: 1
    }] : [],
    aggField: city ? "pub_year" : 'city',
    prefixNum: 0,
    prefix: "",
    sortType: city ? 2 : 0,
    aggNum: 0,
    esFilterObjects: [],
    esNestedObjects: [],
  });
  let aggInfo = (res.data?.aggInfo || [])
  let obj = {
    category: aggInfo.map(item => item.name),
    seriesData: aggInfo.map(item => item.count)
  }
  return obj
}

// 统计机构贡献---成果
export const getJGGX = async () => {
  let res = await getAggApi({
    moduleCode: "medical_search_all",
    datasetCodes: ['medical_journal_paper_data', 'medical_report_data', 'medical_standard_data', 'medical_patent_data'],
    esSearchObjects: [],
    aggField: 'org_name.raw',
    prefixNum: 0,
    prefix: "",
    sortType: 0,
    aggNum: 0,
    esFilterObjects: [],
    esNestedObjects: [],
  });
  let aggInfo = (res.data?.aggInfo || [])
  return aggInfo
}
// 统计资源产出--期刊、专利、标准：按年分统计
export const getZYCC = async () => {
  let datas = [
    {
      name: '期刊',
      moduleCode: 'medical_search_journal_paper',
      data: [],
      seriesData: []
    },
    {
      name: '专利',
      moduleCode: 'medical_search_patent',
      data: [],
      seriesData: []
    },
    {
      name: '标准',
      moduleCode: 'medical_search_standard',
      data: [],
      seriesData: []
    },
  ]
  for (let i = 0; i < datas.length; i++) {
    let res = await getAggApi({
      moduleCode: datas[i].moduleCode,
      datasetCodes: [],
      esSearchObjects: [],
      aggField: 'pub_year',
      prefixNum: 0,
      prefix: "",
      sortType: 0,
      aggNum: 0,
      esFilterObjects: [],
      esNestedObjects: [],
    });
    let aggInfo = (res.data?.aggInfo || [])
    datas[i].data = aggInfo
  }
  // console.log(datas);
  // 处理数据
  let cat = []
  datas.forEach(item => {
    cat.push(...item.data.map(it => it.name))
  })
  cat = [...new Set(cat)].sort()
  // console.log(cat);
  cat.forEach(c => {
    datas.forEach(item => {
      let sameName = item.data.find(it => it.name == c)
      if (sameName) {
        item.seriesData.push(sameName.count)
      } else {
        item.seriesData.push(0)
      }
    })
  })
  let seriesDatas = datas.map(item => {
    return {
      name: item.name,
      type: "line",
      areaStyle: {
        opacity: 0.2,
      },
      emphasis: {
        focus: "series",
      },
      symbol: "circle", //将小圆点改成实心 不写symbol默认空心
      symbolSize: 0, //小圆点的大小
      smooth: true,
      data: item.seriesData
    }
  })
  console.log(seriesDatas);
  return {
    category: cat,
    seriesData: seriesDatas
  }
}

// 统计每年企业数量
export const getCompanyCounts = async () => {
  let res = await getAggApi({
    moduleCode: "medical_search_org",
    datasetCodes: [],
    esSearchObjects: companySearchCondtion,
    aggField: 'register_year',
    prefixNum: 0,
    prefix: "",
    sortType: 1,
    aggNum: 0,
    esFilterObjects: [],
    esNestedObjects: [],
  });
  let aggInfo = (res.data?.aggInfo || []).reverse()
  let category = []
  let seriesData = []
  aggInfo.forEach(item => {
    category.push(item.name)
    seriesData.push(item.count)
  })
  // console.log(aggInfo);
  return {
    category,
    seriesData
  }
}
// 企业类型组成
export const getCompanyMidType = async () => {
  let res = await getAggApi({
    moduleCode: "medical_search_org",
    datasetCodes: [],
    esSearchObjects: companySearchCondtion,
    aggField: 'industry_gbmidclass.raw',
    prefixNum: 0,
    prefix: "",
    sortType: 0,
    aggNum: 13,
    esFilterObjects: [],
    esNestedObjects: [],
  });
  let total = res?.data?.total || 0
  let aggInfo = (res.data?.aggInfo || []).map(item => {
    return {
      name: item.name,
      value: item.count
    }
  }).filter(item => item.name != '兽用药品制造')
  return { aggInfo, total }
}
// 企业注册资本排名
export const getRegisterCapital = async () => {
  let res = await searchListApi({
    "moduleCode": "medical_search_org",
    "datasetCodes": [],
    "pageIndex": 1,
    "pageSize": 50,
    "maxPage": 0,
    "esSearchObjects": companySearchCondtion,
    "esSortObjects": [
      {
        "field": "register_capital",
        "type": 1
      }
    ],
    "highlightFields": [],
    "esFilterObjects": [],
    "esNestedObjects": []
  })
  return res?.data?.hits || []
}
/* 俄乌冲突专用 */
/* 获取所有模块配置数据 */
export const getAllCfgModule = async () => {
  let allModuleInfo = store.state.allModuleInfo
  if (allModuleInfo?.length > 0) {
    return allModuleInfo
  } else {
    let res = await getAllCfgModuleApi()
    if (res.success) {
      store.commit('saveAllCfgModule', res?.data || [])
      return res?.data || []
    }
  }
}